import { useMutation } from "@apollo/react-hooks";
import { ChoiceList, Modal } from "@shopify/polaris";
import React, { useCallback, useReducer } from "react";
import { MARK_ORDER_LABEL_SPLIT_TAG } from "../../graphql/mutations";
import { arrInvalid, handleError, reducerFn } from "../../helper";
import useTimeout from "../../hooks/useTimeout";
import { useToastContext } from "../shared/ToastContext";

export default function TiktokMarkOrderSplit({
    open,
    onClose,
    refetch,
    orderIDs,
    handleCompleted,
}) {
    const [state, setState] = useReducer(reducerFn, {
        selected: ["no"],
    });

    const { setNotify, toggleToast } = useToastContext();

    const [setDelay] = useTimeout();
    const [markOrderSplit, { loading }] = useMutation(
        MARK_ORDER_LABEL_SPLIT_TAG,
        {
            onCompleted: () => {
                setNotify({ msg: "Mark as Order Split success", err: false });

                setDelay(() => {
                    onClose && onClose();
                    refetch && refetch();
                    handleCompleted && handleCompleted();
                }, 2000);
            },
            onError: (err) => {
                setNotify({ msg: handleError(err?.toString()), err: true });
            },
        },
    );

    const handleSubmit = useCallback(() => {
        if (arrInvalid(orderIDs)) return;

        markOrderSplit({
            variables: {
                ids: orderIDs,
                isSplit:
                    state.selected?.length > 0 && state.selected[0] === "yes",
            },
        });
    }, [markOrderSplit, setNotify, toggleToast, orderIDs, state.selected]);

    const handleStateChange = useCallback((selected) => {
        setState({ selected });
    }, []);

    return (
        <Modal
            title="Mark as Order Label Split"
            sectioned
            open={open}
            onClose={onClose}
            secondaryActions={[{ content: "Cancel", onAction: onClose }]}
            primaryAction={{
                content: "Submit",
                onAction: handleSubmit,
                loading: loading,
            }}
        >
            <ChoiceList
                choices={[
                    { value: "no", label: "No" },
                    { value: "yes", label: "Yes" },
                ]}
                selected={state.selected}
                title="Is Order Label Split"
                onChange={handleStateChange}
            />
        </Modal>
    );
}
